<div>
  <div class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div class="col-12">
    <h5>{{ 'ecClaim.injuryDetails.title' | translate}}
      <a href="javascript:;" (click)="open(injuryDetails)"><i class="hits"></i></a>
    </h5>
    <p>{{ 'ecClaim.injuryDetails.subHeading' | translate}}</p>
  </div>
  <br/>
  <div class="row col-12">
    <div class="col-lg-9 col-md-12">
      <form [formGroup]="injuryDetailsForm">
        <div class="form-group">
          <qnect-ui #EC_ACCIDENT_TYPE [fieldId]="'EC_ACCIDENT_TYPE'" [formGroup]="injuryDetailsForm" name="accidentType"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="accidentDetails.getAccidentType() == '4'">
          <qnect-ui #EC_ACCIDENT_FALL_FROM_HEIGHT [fieldId]="'EC_ACCIDENT_FALL_FROM_HEIGHT'" [formGroup]="injuryDetailsForm" name="fallFromHeightOf"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="accidentDetails.getAccidentType() == '17_15'">
          <qnect-ui #EC_ACCIDENT_TYPE_OTHERS [fieldId]="'EC_ACCIDENT_TYPE_OTHERS'" [formGroup]="injuryDetailsForm" name="accidentTypeOthers"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_INJURY_DIAGNOSIS [fieldId]="'EC_INJURY_DIAGNOSIS'" [formGroup]="injuryDetailsForm" name="diagnosis"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_INJURY_DESCRIPTION [fieldId]="'EC_INJURY_DESCRIPTION'" [formGroup]="injuryDetailsForm" name="description"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_INJURY_INVOLVE_AGENTS [fieldId]="'EC_INJURY_INVOLVE_AGENTS'" [formGroup]="injuryDetailsForm" name="isAgentInvolved"></qnect-ui>
        </div>
        <ng-container *ngIf="accidentDetails.getIsAgentInvolved()">
          <div class="form-group">
            <qnect-ui #EC_INJURY_AGENTS_INVOLVED [fieldId]="'EC_INJURY_AGENTS_INVOLVED'" [formGroup]="injuryDetailsForm" name="agentsInvolved"></qnect-ui>
          </div>
          <div class="form-group" *ngIf="this.isAgentsInvolvedContain(accidentDetails.getAgentsInvolved(), 'other machinery')">
            <qnect-ui #EC_INJURY_OTHER_MACHINERY_TYPE [fieldId]="'EC_INJURY_OTHER_MACHINERY_TYPE'" [formGroup]="injuryDetailsForm" name="otherMachineryType"></qnect-ui>
          </div>
          <div class="form-group" *ngIf="this.isAgentsInvolvedContain(accidentDetails.getAgentsInvolved(), 'other machinery')">
            <qnect-ui #EC_INJURY_PART_CAUSING [fieldId]="'EC_INJURY_PART_CAUSING'" [formGroup]="injuryDetailsForm" name="partCausingInjury"></qnect-ui>
          </div>
          <div class="form-group" *ngIf="this.isAgentsInvolvedContain(accidentDetails.getAgentsInvolved(), 'other')">
            <qnect-ui #EC_INJURY_AGENTS_INVOLVED_OTHER [fieldId]="'EC_INJURY_AGENTS_INVOLVED_OTHER'" [formGroup]="injuryDetailsForm" name="agentsInvolvedOthers"></qnect-ui>
          </div>
          <div class="form-group">
            <qnect-ui #EC_INJURY_DESCRIBE_AGENTS [fieldId]="'EC_INJURY_DESCRIBE_AGENTS'" [formGroup]="injuryDetailsForm" name="agentsDescription"></qnect-ui>
          </div>
        </ng-container>
        <div class="form-group">
          <qnect-ui #EC_INJURY_TREATMENT_RECEIVED [fieldId]="'EC_INJURY_TREATMENT_RECEIVED'" [formGroup]="injuryDetailsForm" name="isTreatmentReceived"></qnect-ui>
        </div>
        <div class="form-group">
          <qnect-ui #EC_INJURY_TREATMENT_TYPE [fieldId]="'EC_INJURY_TREATMENT_TYPE'" [formGroup]="injuryDetailsForm" name="treatmentType"></qnect-ui>
        </div>
      </form>
    </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
    <div class="col-12 col-md-12">
      <app-body-parts (emitShowLabelTxt)="showTooltip($event)" (emitHideLabelTxt)="hideToolTip()" #bodyParts></app-body-parts>
    </div>
  </div>
  <div class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

<ng-template #injuryDetails let-c="close" let-d="dismiss" class="white-popup mfp-hide">
  <div class="modal-header">
    <h5 style="padding-left:55px;">{{'ecClaim.injuryDetails.title' | translate}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal_content" [innerHTML]="'ecClaim.injuryDetails.injuryContent' | translate"></div>
</ng-template>